import axios from 'axios';

const USER_API_BASE_URL = process.env.REACT_APP_API_URL + '/api/admin/user/';
const CUSTOMER_API_BASE_URL = process.env.REACT_APP_API_URL + '/api/admin/customer/';

class AdminService {
    search(customerCodes) {
        let query = {
            customerCodes: customerCodes
        }
        return axios.post(USER_API_BASE_URL + 'search', query);
    }

    searchIMA(criterias){
        return axios.post(USER_API_BASE_URL + 'search/ima', criterias);
    }

    getUser(userID) {
        return axios({
            url: USER_API_BASE_URL + userID,
            method: 'get'
        })

    }

    updateUser(user) {
        return axios.patch(USER_API_BASE_URL + 'update', user);
    }

    updateUserPassword(userID, authent) {
        return axios.patch(USER_API_BASE_URL + userID + '/password', authent);
    }

    resetUserPassword(mail, lang) {
        return axios.put(USER_API_BASE_URL + 'reset-password?mail=' + mail + '&lang=' + lang);
    }

    createUser(user) {
        return axios.post(USER_API_BASE_URL + 'create', user);
    }

    getCutomer(siteCode, customerCode) {
        return axios.get(CUSTOMER_API_BASE_URL + '?' + 'siteCode=' + siteCode + '&customerCode=' + customerCode)
    }

    getCutomersLogo(query) {
        return axios.post(CUSTOMER_API_BASE_URL + 'logo', query)
    }

    getCutomers(siteCode, customerCode) {
        return axios.get(CUSTOMER_API_BASE_URL + 'search' + (customerCode && siteCode ? '?' + 'siteCode=' + siteCode + '&customerCode=' + customerCode : ''))
    }

    saveCustomer(customer, logo) {
        const formData = new FormData();
        formData.append('file', logo)
        formData.append('customer', JSON.stringify(customer))
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        return  axios.post(CUSTOMER_API_BASE_URL, formData, config)
    }

    enableUser(userID, enable) {
        const query = {
            userID: userID,
            enable: enable
        }
        return axios.post(USER_API_BASE_URL + 'enable', query);
    }

    enableCustomer(customerID, enable) {
        const query = {
            customerID: customerID,
            enable: enable
        }
        return axios.post(CUSTOMER_API_BASE_URL + 'enable', query);
    }
}
export default new AdminService();